import { css } from '@/styled-system/css';

export const formStyles = css.raw({
  '& .c11n_form-actions': {
    marginBlockStart: 'layout.loose',
  },
  '& .c11n_form-field:not(:last-child)': {
    marginBlockEnd: 'layout.tight',
  },
  '& .c11n_field-set:not(:last-child)': {
    marginBlockEnd: 'layout.tight',
  },
});
